import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import { apiURL } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceOrderDetail = (props) => {
  const { t } = useTranslation()
  const orderId = props.orderId

  const [InputData, setInputData] = useState({
    id: orderId,
    remark: '',
    quantity_notations: [],
    notations: [],
    room_notations: [],
    special_notations: [],
  })

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    {},
    'get'
  )

  const setInputDataQuantityNotation = function (key, value) {
    let a = InputData.quantity_notations
    a[key] = value
    setInputData({
      ...InputData,
      quantity_notations: a,
    })
  }
  const setInputDataNotation = function (key, value) {
    let a = InputData.notations
    a[key] = value
    setInputData({
      ...InputData,
      notations: a,
    })
  }
  const setInputDataRoomNotation = function (key, value) {
    let a = InputData.room_notations
    a[key] = value
    setInputData({
      ...InputData,
      room_notations: a,
    })
  }
  const setInputDataSpecialNotation = function (key, value) {
    let a = InputData.special_notations
    a[key] = value
    setInputData({
      ...InputData,
      special_notations: a,
    })
  }

  // initial call to get the order with id = orderId
  if (data === null && error === null && partnerPortalUrl === null) {
    setPartnerPortalUrl(
      apiURL('orders_detail?orders_detail%5Bid%5D=' + orderId)
    )
  }

  // Form-Submit
  const [Fdata, setFdata] = useState(false)
  const [partnerPortalUrlSubmit, setPartnerPortalUrlSubmit] = useState(null)
  const { submitData, submitLoading, submitError } = useAxiosPartnerPortal(
    partnerPortalUrlSubmit,
    Fdata,
    'put'
  )

  const FormSubmit = (e) => {
    e.preventDefault()

    const submitData = new FormData()
    submitData.append('orders_detail[id]', InputData.id)
    submitData.append('orders_detail[remark]', InputData.remark)
    InputData.quantity_notations.map((quantity_notation) => {
      submitData.append(
        'orders_detail[quantity_notations][]',
        quantity_notation
      )
    })
    InputData.notations.map((notation) => {
      submitData.append('orders_detail[notations][]', notation)
    })
    InputData.room_notations.map((room_notation) => {
      submitData.append('orders_detail[room_notations][]', room_notation)
    })
    InputData.special_notations.map((special_notation) => {
      submitData.append('orders_detail[special_notations][]', special_notation)
    })

    setFdata(submitData)
    setPartnerPortalUrlSubmit(apiURL('orders_detail'))

    return true
  }

  // @todo: LoadingSpinner läuft nicht beim 2. Submit: submitLoading
  // @todo: Nach erfolgreichem 2. Submit sollte noch was brauchbares passieren

  // useEffect(() => {
  //   if (submitData) {
  //     if (typeof window !== 'undefined') {
  //       window.location.href = window.location.href + '?id=' + data.id
  //     }
  //   }
  // }, [submitData])

  return (
    <div className="spa-block-full">
      <div data-spa-result-for="orders_detail">
        <div data-spa-type="orders_detail">
          {loading && <LoadingSpinner />}
          {submitLoading && <LoadingSpinner />}
          {data && (
            <form onSubmit={(e) => FormSubmit(e)}>
              <input type="hidden" name="id" defaultValue={props.orderId} />
              <div className="mb-1">
                <div className="row form-label-group mb-1">
                  <div className="col-md-4">
                    <label>{t('generic.spa.order_detail.customer')}</label>
                  </div>
                  <div className="col-md-8">{data.data.customer_number}</div>
                </div>

                <div className="row form-label-group mb-1">
                  <div className="col-md-4">
                    <label>{t('generic.spa.order_detail.created_at')}</label>
                  </div>
                  <div className="col-md-8">{data.data.created_at}</div>
                </div>

                <div className="row form-label-group mb-1">
                  <div className="col-md-4">
                    <label>{t('generic.spa.order.order_number')}</label>
                  </div>
                  <div className="col-md-8">{data.data.number}</div>
                </div>

                <div className="row form-label-group mb-1">
                  <div className="col-md-4">
                    <label>{t('generic.spa.order.submission_number')}</label>
                  </div>
                  <div className="col-md-8">{data.data.submission_number}</div>
                </div>

                <div className="row form-label-group mb-1">
                  <div className="col-md-4">
                    <label>{t('generic.spa.order.consignee')}</label>
                  </div>
                  <div className="col-md-8">{data.data.consignee}</div>
                </div>

                <div className="row form-label-group mb-1">
                  <div className="col-md-4">
                    <label>{t('generic.spa.order_detail.date_notice')}</label>
                  </div>
                  <div className="col-md-8"></div>
                </div>
              </div>

              <div className="mb-1">
                <div className="row form-label-group mb-1">
                  <div className="col-md-4">
                    <label>{t('generic.spa.order_detail.remark')}</label>
                  </div>
                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control"
                      name="remark"
                      onChange={(e) =>
                        setInputData({
                          ...InputData,
                          remark: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="mb-1">
                {Object.keys(data.data.parsed_garbio_file).map((key, index) => (
                  <div key={index}>
                    <table className="table table-condensed" key={key}>
                      <thead>
                        <tr>
                          {t(
                            'generic.spa.order_detail.garbio_file_columns'
                          ).map((c, index) => (
                            <th key={index}>{c}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{data.data.parsed_garbio_file[key].number}</td>
                          <td>
                            {data.data.parsed_garbio_file[key].material_number}
                          </td>
                          <td>
                            {data.data.parsed_garbio_file[key].text_short}
                          </td>
                          <td>{data.data.parsed_garbio_file[key].text_long}</td>
                          <td>
                            <input
                              type="number"
                              min="0"
                              step="1"
                              className="form-control"
                              name="quantity_notations[]"
                              defaultValue={
                                data.data.parsed_garbio_file[key]
                                  .position_quantity
                              }
                              onChange={(e) =>
                                setInputDataQuantityNotation(
                                  key - 1,
                                  e.target.value
                                )
                              }
                            />
                            {/* der defaultValue soll in den InputData sein */}
                            {InputData.quantity_notations[key - 1] ===
                              undefined &&
                              setInputDataQuantityNotation(
                                key - 1,
                                data.data.parsed_garbio_file[key]
                                  .position_quantity
                              )}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table className="table table-condensed">
                      <thead>
                        <tr>
                          <th style={{ width: '33%' }}>
                            {t('generic.spa.order_detail.key')}
                          </th>
                          <th>{t('generic.spa.order_detail.value')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.data.parsed_garbio_file[key].attributes.map(
                          (a, index) => (
                            <tr key={index}>
                              <td>{a.name}</td>
                              <td>{a.value}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>

                    <table className="table table-condensed">
                      <thead>
                        <tr>
                          <th style={{ width: '33%' }}>
                            {t('generic.spa.order_detail.notations')}
                          </th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{t('generic.spa.order_detail.notation')}</td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              name="notations[]"
                              onChange={(e) =>
                                setInputDataNotation(key - 1, e.target.value)
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>{t('generic.spa.order_detail.room_notation')}</td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              name="room_notations[]"
                              onChange={(e) =>
                                setInputDataRoomNotation(
                                  key - 1,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {t('generic.spa.order_detail.special_notation')}
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              name="special_notations[]"
                              onChange={(e) =>
                                setInputDataSpecialNotation(
                                  key - 1,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))}
                {Object.keys(data.data.parsed_garbio_file).length === 0 &&
                  t('generic.spa.order_detail.no_items')}
              </div>

              <button className="btn btn-primary btn-sm mt-1" type="submit">
                {t('generic.spa.order_detail.submit')}
              </button>
            </form>
          )}

          {error && (
            <div className="spa-block-full mt-2">
              <p>{t('generic.spa.no_results')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SapServiceOrderDetail
